import type {ReactNode} from 'react';
import {alpha, Box, Stack, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import type {NavigationCardGradient} from './constants';

type NavigationCardProps = {
    title: string;
    icon: ReactNode;
    route: string;
    color: string;
    gradient?: NavigationCardGradient;
    closeAppNavigation: () => void;
};

export const NavigationCard = ({
    title,
    icon,
    route,
    color,
    gradient,
    closeAppNavigation,
}: NavigationCardProps) => {
    const navigate = useNavigate();
    return (
        <Stack
            sx={{
                background: gradient?.background ?? alpha(color, 0.04),
                borderRadius: '8px',
                cursor: 'pointer',
                padding: '8px 6px',
                minWidth: 74,
                '&:hover': {
                    background: gradient?.background ?? alpha(color, 0.08),
                    filter: gradient ? 'brightness(1.4)' : undefined,
                },
            }}
            onClick={() => {
                navigate(route);
                closeAppNavigation();
            }}
            alignItems='center'
            justifyContent='center'
            gap='2px'
        >
            <Box
                sx={{
                    color: color,
                    width: 32,
                    height: 32,
                    fontSize: 32,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {icon}
            </Box>
            <Typography
                sx={{
                    fontSize: '12px',
                    lineHeight: 1.27,
                    letterSpacing: '0.17px',
                    fontWeight: 400,
                    whiteSpace: 'nowrap',
                    ...(gradient && {
                        background: gradient.text,
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }),
                }}
                color={gradient ? undefined : color}
            >
                {title}
            </Typography>
        </Stack>
    );
};
